import { mapGismeteoPrecipitationSlice } from "./MapGismeteoPrecipitationSlice"
import { mapPathSlice } from "./MapPathSlice"
import { mapRepairPlanSlice } from "./MapRepairPlan"
import { mapRoadWorksWithNormativitiesSlice } from "./MapRoadWorksWithNormativitiesSlice"
import { mapWaysideLandLotsSlice } from "./MapWaysideLandLotsSlice"

export const mapActions = {
    roadWorksWithNormativities: mapRoadWorksWithNormativitiesSlice.actions,
    path: mapPathSlice.actions,
    gismeteoPrecipitation: mapGismeteoPrecipitationSlice.actions,
    waysideLandLots: mapWaysideLandLotsSlice.actions,
    repairPlan: mapRepairPlanSlice.actions,
    // roadAccidents: mapRoadAccidentsSlice.actions
}

export type MapName = keyof typeof mapActions